import React, { useEffect, useState } from 'react';
import {
  Input,
  TagError,
  DivInputContainer,
  DivExpiredToken,
  SpanExpired,
  ButtonExpired,
} from './styles';
import ProgressBar from '@ramonak/react-progress-bar';
import moment from 'moment';
import Loading from '../Loading';
import { useSelector } from 'react-redux';
interface InputToken {
  value: string;
  error: boolean;
  bottom?: string;
  change: Function;
  countDown?: boolean;
  onClickButtonExpired?: (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => void;
  onkeypress?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  setError?: (value: boolean) => void;
}

const colors = ['#24C952', '#FAB100', '#FF5670'];

function InputToken({
  value,
  error,
  bottom,
  change,
  countDown,
  onClickButtonExpired,
  onkeypress,
  setError,
}: InputToken) {
  const { tokenExpirationTime, tokenSentTime } = useSelector(
    (state: ApplicationState) => {
      return {
        tokenExpirationTime: Number.parseInt(state.config.tempoExpiracaoToken),
        tokenSentTime: state.auth.tokenSentTime,
      };
    }
  );

  const calcPerc = () => {
    const diff = moment().diff(moment(tokenSentTime), 'milliseconds');
    const totalMilliSeconds = (tokenExpirationTime ?? 0) * 60 * 1000;
    const diffMilliSeconds = totalMilliSeconds - diff;
    return (100 / totalMilliSeconds) * diffMilliSeconds;
  };

  const [perc, setPerc] = useState(calcPerc());
  const [loading, setLoading] = useState(false);

  const getColorIndex = () => {
    if (perc < 30) return 2;
    else if (perc < 50) return 1;
    else return 0;
  };

  useEffect(() => {
    if (!countDown || perc <= 0) {
      if (setError) setError(true);
      return;
    }

    const timer = setInterval(() => {
      setPerc(calcPerc());
    }, 500);

    return () => clearInterval(timer);
  }, [perc]);

  const getProgressBar = () => {
    if (countDown) {
      return (
        <div style={{ width: '100%', height: '3px' }}>
          <ProgressBar
            completed={perc}
            borderRadius='0px'
            isLabelVisible={false}
            bgColor={colors[getColorIndex()]}
            baseBgColor='#F5F6FD'
          />
        </div>
      );
    } else {
      return <></>;
    }
  };

  const handleClickButtonExpired = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    setLoading(true);
    if (onClickButtonExpired) onClickButtonExpired(event);
    setLoading(false);
    setPerc(100);
    if (setError) setError(false);
  };

  return (
    <>
      {countDown && perc <= 0 ? (
        <DivExpiredToken bottom={bottom} error={error}>
          <SpanExpired>
            <b>Seu token expirou!</b> Você pode gerar um novo token de acesso
            clicando no botão ao lado
          </SpanExpired>
          <ButtonExpired color={'primary'} onClick={handleClickButtonExpired}>
            {loading ? <Loading /> : 'GERAR NOVO TOKEN'}
          </ButtonExpired>
        </DivExpiredToken>
      ) : (
        <DivInputContainer bottom={bottom} error={error}>
          <Input
            id={'token'}
            mask='9 9 9 9 9 9'
            type='tel'
            alwaysShowMask={true}
            value={value}
            onChange={(e) => change(e)}
            onKeyPress={onkeypress}
          />
          {getProgressBar()}
        </DivInputContainer>
      )}
      {error && <TagError>Token inválido</TagError>}
    </>
  );
}

export default InputToken;
